import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

interface PageLayoutProps {
  children: React.ReactNode;
  title?: string;
  showSearch?: boolean;
  searchPlaceholder?: string;
  onSearch?: (searchTerm: string) => void;
  headerActions?: React.ReactNode;
  className?: string;
  showHeader?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  title,
  showSearch = false,
  searchPlaceholder,
  onSearch,
  headerActions,
  className = '',
  showHeader = true
}) => {
  return (
    <div className={`app-container ${className}`}>
      <Sidebar />
      
      <main className="main-content">
        {showHeader && (
          <Header
            title={title}
            showSearch={showSearch}
            searchPlaceholder={searchPlaceholder}
            onSearch={onSearch}
            actions={headerActions}
          />
        )}
        
        <div className="page-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default PageLayout;